import { render } from "./familiaForm.vue?vue&type=template&id=4a006122&scoped=true"
import script from "./familiaForm.vue?vue&type=script&lang=js"
export * from "./familiaForm.vue?vue&type=script&lang=js"

import "./familiaForm.vue?vue&type=style&index=0&id=4a006122&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a006122"]])

export default __exports__